import { GetShopifyInventoryDocument } from '@/gql/shopify/generated/graphql'
import { getShopifyUrqlClient } from '@/gql/clients/shopify-urql-client'

export const SHOPIFY_QUERY_RATE = 10
export const shopifyPublicAccessToken = '9a6a9f8ed248319f39c9c491f2361f55'

// The variant ID of the product.
// NOTE: All products have a variant ID, even if you haven't added multiple variants to the product.
//       The easiest way to find this is to navigate to the product in the Shopify admin and
//       then add `.json` to the end of the URL.
//       e.g. https://admin.shopify.com/store/dardans-curated-ab-store/products/7411351715909.json
export const lampVariantId = `gid://shopify/ProductVariant/${process.env.NEXT_PUBLIC_SHOPIFY_LAMP_VARIANT_ID}`
const lampProductId = `gid://shopify/Product/${process.env.NEXT_PUBLIC_SHOPIFY_LAMP_PRODUCT_ID}`

export type ShopifyProduct = {
  productId: string
  variantId: string
}

export const getLampInventory = async (): Promise<number> => {
  return getProductInventory(lampProductId, false)
}

export const getProductInventory = async (productId: string, useCache = true): Promise<number> => {
  const shopifyClient = await getShopifyUrqlClient()
  const { data, error } = await shopifyClient.query(
    GetShopifyInventoryDocument,
    {
      id: productId
    },
    {
      requestPolicy: useCache ? 'cache-first' : 'network-only'
    }
  )

  const quantityRemaining = data?.product?.variants?.edges?.[0]?.node?.quantityAvailable ?? undefined

  if (quantityRemaining === undefined || error) {
    console.error('Failed to get lamp inventory', error)
    throw new Error('Failed to get lamp inventory', error)
  }
  return quantityRemaining
}
